import styled from 'styled-components'
import { Media } from '../../theme'

interface BackgroundProps {
  desktop: string
  mobile: string
  large?: string
  zIndex?: number
}

export const Background = styled.div<BackgroundProps>`
  position: absolute;
  inset: 0;
  z-index: ${({ zIndex }) => zIndex ?? -1};
  background: url(${({ desktop }) => desktop}) no-repeat;
  background-size: cover;

  ${Media.lessThan(Media.small)} {
    background: url(${({ mobile }) => mobile}) no-repeat;
    background-size: cover;
  }

  ${({ large }) =>
    large &&
    `
    @media (min-width: 2560px) {
      background: url(${large}) no-repeat center center;
      background-size: cover;
    }
  `}
`
